import {
  Alert,
  Box,
  FormControl,
  InputLabel,
  Snackbar,
  Typography,
  useTheme,
} from '@mui/material';
import { usePasswordResetRequest } from '_api';
import { InitialRouteMap } from '_constants';
import { PrimaryButton, StyledOutlinedInput, TextButton } from 'components/atoms';
import React, { ChangeEvent, useState } from 'react';
import { useNavigateTo } from 'utils';

import { LoginPaper } from './styles';

export const ForgotPassword = () => {
  const theme = useTheme();
  const navigate = useNavigateTo();
  const { mutateAsync: ResetPasswordRequest } = usePasswordResetRequest();
  const [email, setEmail] = useState('');
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const toLogin = () => navigate(InitialRouteMap.LOGIN);

  const handleInputChange = ({
    target: { value: newValue },
  }: ChangeEvent<HTMLInputElement>) => {
    setEmail(newValue);
  };

  const sendReset = () => {
    ResetPasswordRequest({ email })
      .then(() => {
        setShowSuccess(true);
      })
      .catch(() => {
        setShowError(true);
      });
  };

  return (
    <LoginPaper>
      <img src="/img/logo-sign-in.png" alt={''} style={{ maxWidth: '20%' }} />
      {!showSuccess ? (
        <>
          <FormControl required={true} style={{ width: '100%' }}>
            <StyledOutlinedInput onChange={handleInputChange} />
            <InputLabel sx={{ background: theme.palette.background.paper }}>
              Email Address
            </InputLabel>
          </FormControl>
          <PrimaryButton onClick={sendReset} sx={{ width: '100%' }}>
            SEND RESET LINK
          </PrimaryButton>
          <TextButton onClick={toLogin} sx={{ width: '100%' }}>
            RETURN TO SIGN IN
          </TextButton>
        </>
      ) : (
        <>
          <Box sx={{ margin: 'auto', marginBottom: '10px', textAlign: 'center' }}>
            <Typography variant="body1">Password reset link sent.</Typography>
            <Typography variant="body1">
              Please check your email to reset your password.
            </Typography>
          </Box>
          <PrimaryButton onClick={toLogin} sx={{ width: '100%' }}>
            RETURN TO SIGN IN
          </PrimaryButton>
        </>
      )}
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={5000}
        onClose={() => setShowError(false)}
        open={showError}
      >
        <Alert onClose={() => setShowError(false)} severity="error" variant="filled">
          Reset password attempt failed, please try again
        </Alert>
      </Snackbar>
    </LoginPaper>
  );
};
